import React from "react"
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Navbar from "./Navbar"
import Menu from "./Menu"
import Footer from "./Footer"
import { FloatButton } from 'antd'
import category from '@/assets/js/category'
import { loadLiveChat } from '@/utils/liveChat';
import { loadGtm } from '@/utils/gtm';
import { loadMatomo } from "@/utils/matomo";

interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  useChristmasTheme?: boolean; // 是否使用圣诞主题
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function DefaultLayout(props: LayoutProps) {
  const router = useRouter();

  useEffect(() => {
    function handleWindowLoad() {
      // 排除详情页，加载LiveChat
      if (!router.pathname.includes('/product-detail/')) {
        loadLiveChat();
      }
      loadMatomo();
      loadGtm();
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  return (
    <div>
      <Navbar
        wideScreen={props.wideScreen}
        categoryData={category}
        useChristmasTheme={router.pathname.includes('/myaccount') ? false : true}
        sticky={props.notStickyNavbar ? false : true}
      />

      <Menu 
        wideScreen={props.wideScreen}
        categoryData={category}
        useChristmasTheme={router.pathname.includes('/myaccount') ? false : true} 
      />

      <main style={{ background: '#F5F5F5' }}>{props.children}</main>

      <Footer />
      <FloatButton.BackTop />
    </div>
  )
}